const emergencyNp = {
  buttons: {
    gas: 'ग्यास सिलिन्डर',
    medicine: 'आपतकालीन औषधि',
  },
  common: {
    nameLabel: 'तपाईंको नाम',
    phoneLabel: 'मोबाइल नम्बर',
    villageLabel: 'गाउँ/क्षेत्र',
    houseNumberLabel: 'घर नम्बर',
    detailsLabel: 'थप जानकारी',
    detailsPlaceholder: 'यदि कुनै विशेष निर्देशन छ भने',
    districtLabel: 'जिल्ला',
    upazillaLabel: 'उपजिल्ला',
    cancel: 'रद्द गर्नुहोस्',
  },
  gas: {
    title: 'ग्यास सिलिन्डर रिफिल',
    companyLabel: 'ग्यास कम्पनी',
    cylinderSizeLabel: 'सिलिन्डर साइज',
    cylinderSizePlaceholder: 'सिलिन्डर साइज छान्नुहोस्',
    quantityLabel: 'परिमाण',
    companies: {
      bashundhara: 'Bashundhara Gas',
      jamuna: 'Jamuna Gas',
      omera: 'Omera Gas',
      beximco: 'Beximco Gas',
      fresh: 'Fresh Gas',
      totalgaz: 'Totalgaz',
      others: 'अन्य',
    },
    cylinderSizeOptions: {
      "12kg": '१२ किलोग्राम',
      "33kg": '३३ किलोग्राम',
      "45kg": '४५ किलोग्राम',
    },
    price: {
      header: 'मूल्य विवरण',
      unitPrice: 'एकाइ मूल्य',
      subtotal: 'उप-योग',
      delivery: 'डेलिभरी शुल्क',
      total: 'कुल रकम',
      note: '* क्यास अन डेलिभरी उपलब्ध',
      unitSuffix: 'वटा',
    },
    orderNow: 'अर्डर गर्नुहोस्',
  },
  medicine: {
    title: 'आपतकालीन औषधि सेवा',
    medicineNameLabel: 'औषधिको नाम',
    medicineNamePlaceholder: 'कुन औषधि आवश्यक छ?',
    urgencyLabel: 'जरुरी स्तर',
    urgencyOptions: {
      normal: 'सामान्य',
      urgent: 'जरुरी',
      emergency: 'अति जरुरी',
    },
    prescriptionLabel: 'प्रिस्क्रिप्सन (भएमा)',
    prescriptionPlaceholder: 'डाक्टरको प्रिस्क्रिप्सन वा औषधिको विवरण',
    uploadNote: 'प्रिस्क्रिप्सन अपलोड वैकल्पिक हो; तपाईंले छवि वा PDF अपलोड गर्न सक्नुहुन्छ।',
    uploadButton: 'प्रिस्क्रिप्सन अपलोड गर्नुहोस् (वैकल्पिक)',
    selectedFilePrefix: 'चयन गरिएको फाइल:',
    submit: 'आपतकालीन अर्डर पठाउनुहोस्',
  }
};

export default emergencyNp;


